<div class="last-change">
  <span *ngIf="task.createdOn && createdByUsername">created on {{task.createdOn | date:'dd.MM.yyyy' }} by {{createdByUsername}}</span>
  <span *ngIf="task.updatedOn && updatedByUsername">last change on {{task.updatedOn | date:'dd.MM.yyyy' }} by {{updatedByUsername}}</span>
</div>

<h2>
  <ng-container *ngIf="isNewTask">New task</ng-container>
  <ng-container *ngIf="!isNewTask">Update task</ng-container>
</h2>

<mat-dialog-content class="container" *ngIf="taskDetailFormGroup">

  <div class="container-part">
    <digires-text-input
      [formGroup]="taskDetailFormGroup"
      formCtrlName="name"
      placeholder="Name"
      [initialData]="task.name"
    ></digires-text-input>

    <digires-text-input
      [formGroup]="taskDetailFormGroup"
      formCtrlName="details"
      placeholder="Details"
      [textarea]="true"
      [initialData]="task.details"
    ></digires-text-input>
  </div>

  <div class="container-part">
    <digires-list-input
      [formGroup]="taskDetailFormGroup"
      formCtrlName="status"
      placeholder="Status"
      [items]="statusList"
      [itemToLabel]="statusToLabel"
      [initialData]="task.status"
    ></digires-list-input>

    <digires-date-input
      [formGroup]="taskDetailFormGroup"
      formCtrlName="dueDate"
      placeholder="Due Date"
      [initialData]="task.dueDate"
    ></digires-date-input>

    <digires-team-member-input
      [formGroup]="taskDetailFormGroup"
      [initialData]="task.ownerId"
      [allTeamMembers]="teamMembers"
      formCtrlName="owner"
      placeholder="Owner"
      tooltip="The name of the person that is responsible for this Task."
    ></digires-team-member-input>

    <digires-list-input
      [formGroup]="taskDetailFormGroup"
      formCtrlName="label"
      placeholder="Label"
      [items]="labels"
      [itemToLabel]="labelToLabel"
      [initialData]="task.label"
    ></digires-list-input>
  </div>
</mat-dialog-content>

<mat-dialog-actions *ngIf="taskDetailFormGroup">
  <button mat-button class="btnNeutral" [disabled]="isReadOnly" mat-dialog-close>Cancel</button>
  <button mat-button class="btnNegative" [disabled]="isReadOnly" *ngIf="showDeleteButton()" (click)="deleteTask()">
    Delete
  </button>
  <button mat-button class="btnPositive" [disabled]="isReadOnly || !taskDetailFormGroup.valid" mat-dialog-close="true" (click)="updateTask()">
    Save
  </button>
</mat-dialog-actions>
